import { API_GET_DOMAINS } from '@/api/apiRoutes'
import api from '@/lib/api'
import { IDnsDomain } from '@/types/DnsDomain'

export const postContactHidden = async (id: string) => {
  try {
    const { data } = await api.post<IDnsDomain[]>(
      `${API_GET_DOMAINS}${id}/contact_hidden`
    )

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
